import type { ReactNode } from "react";

export function AccountCard({
  icon,
  title,
  description,
  actions,
  className = "",
  children,
  label,
}: {
  icon: ReactNode;
  title: string;
  description?: string;
  actions?: ReactNode;
  className?: string;
  children: ReactNode;
  label?: string;
}) {
  return (
    <section className={`account-card ${className}`} aria-label={label ?? title}>
      <header className="account-card-head">
        <span className="account-card-icon" aria-hidden="true">{icon}</span>
        <div className="account-card-title">
          <h2>{title}</h2>
          {description && <p>{description}</p>}
        </div>
        {actions && <div className="account-card-actions">{actions}</div>}
      </header>
      <div className="account-card-body">{children}</div>
    </section>
  );
}

export function StatusPill({ tone, children }: { tone: "good" | "warn" | "muted" | "bad"; children: ReactNode }) {
  return <span className={`account-pill account-pill-${tone}`}>{children}</span>;
}
